import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.83325 2.5L17.4999 10L5.83325 17.5V2.5Z",
		fill: "currentColor"
	})
});
export default SvgPlay;
